/* oauth */
/*--------------------------------------------------------------------------------*/
import { cfg } from '../../config';
import * as cookie from '../../lib/cookie';
import { tempLogout } from './template';
const app = document.querySelector<HTMLElement>('#app');
export { authMW } from './midware';
/*--------------------------------------------------------------------------------*/
export const login = () => {
    clearCache();
    // set params
    const state = Math.random().toString(36).slice(-8);
    sessionStorage.setItem(cfg.cookie.STATE, state);
    const query = new URLSearchParams({
        response_type: 'token',
        client_id: cfg.app.CODE,
        redirect_uri: cfg.app.CALLBACK,
        state: state,
    }).toString();
    const url = `${cfg.hub.LOGIN}?${query}`;
    window.location.replace(url);
};
/*--------------------------------------------------------------------------------*/
export const logout = () => {
    clearCache();
    // template
    if (!app) return;
    app.innerHTML = tempLogout;
    app.classList.add('full-page');
    const content = app.querySelector<HTMLElement>('#content')!;
    const loader = app.querySelector<HTMLElement>('#loader')!;
    new Promise(r => setTimeout(r, 400)).then(() => {
        content.style.display = 'block';
        loader.style.display = 'none';
    });
    app.querySelector<HTMLButtonElement>('#btn-login')!.onclick = () => {
        window.location.replace('/login');
    };
};
/*--------------------------------------------------------------------------------*/
export const callback = () => {
    const search = window.location.search;
    const query = new URLSearchParams(search);
    const state = query.get('state');
    const session = sessionStorage.getItem(cfg.cookie.STATE);
    if (state !== session) {
        window.location.replace('/login');
    }
    clearCache();
    // response_type
    const code = query.get('code');
    const token = query.get('token');
    const refresh = query.get('refresh');
    if (code) { /*code*/ }
    if (token) {
        localStorage.setItem(cfg.cookie.TOKEN, token);
        if (refresh && refresh != '') {
            localStorage.setItem(cfg.cookie.REFRESH, refresh);
        }
    }
    window.location.replace('/');
};
/*--------------------------------------------------------------------------------*/
const clearCache = () => {
    cookie.clear();
    localStorage.clear();
    sessionStorage.clear();
};
/*--------------------------------------------------------------------------------*/
